import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import image from "./images/loader.gif";
import styles from "./styles.module.scss";

export function ChooseModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [selected, setSelected] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);

  const validation = Yup.object().shape({
    selected: Yup.array().required("You need to select at least one item"),
  });

  async function runAPI() {
    setOptions([]);
    setSelected(null);

    if (modal.data && modal.data.company_id && modal.name === "choose") {
      switch (modal.data.type) {
        case "vehicle":
          await axios
            .get(
              `/api/vehicle/all?type=vehicle&company_id=${modal.data.company_id}`
            )
            .then(async (res) => {
              res.data.data.data.forEach(async (value, index) => {
                if (!modal.currentList.some((veh) => veh.vin === value.vin)) {
                  setOptions((prev) => [
                    ...prev,
                    {
                      label: `${value.vin} - ${value.make} - ${value.model}`,
                      value,
                    },
                  ]);
                }
              });
            })
            .catch((err) => {
              setModal({});

              context.notification.show(
                "Failed to load vehicle options.",
                "error",
                true,
                "toast",
                "x-circle"
              );
            });
          break;

        case "trailer":
          await axios
            .get(
              `/api/vehicle/all?type=trailer&company_id=${modal.data.company_id}`
            )
            .then(async (res) => {
              res.data.data.data.forEach(async (value, index) => {
                if (!modal.currentList.some((veh) => veh.vin === value.vin)) {
                  setOptions((prev) => [
                    ...prev,
                    {
                      label: `${value.vin} - ${value.make} - ${value.model}`,
                      value,
                    },
                  ]);
                }
              });
            })
            .catch((err) => {
              setModal({});

              context.notification.show(
                "Failed to load trailer options.",
                "error",
                true,
                "toast",
                "x-circle"
              );
            });
          break;

        case "driver":
          await axios
            .get(`/api/driver/all?company_id=${modal.data.company_id}`)
            .then(async (res) => {
              res.data.data.data.forEach(async (value) => {
                if (
                  !modal.currentList.some((driver) => driver.id === value.id)
                ) {
                  setOptions((prev) => [
                    ...prev,
                    {
                      label: `${value.name} - ${value.license_number} - ${value.license_state}`,
                      value,
                    },
                  ]);
                }
              });
            })
            .catch((err) => {
              setModal({});

              context.notification.show(
                "Failed to load trailer options.",
                "error",
                true,
                "toast",
                "x-circle"
              );
            });
          break;

        default:
          break;
      }
    }

    setModalLoading(false);
  }

  useEffect(() => {
    runAPI();
  }, [modal]);

  return (
    <Fragment>
      {modal.name === "choose" &&
        (modalLoading ? (
          <div className={styles.background}>
            <div className={styles.wrapper}>
              <div
                className={styles.insideWrapper}
                style={{
                  height: 400,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={image}
                  alt="loading"
                  style={{ width: "25px", borderRadius: 25 }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.background}>
            <div className={styles.wrapper}>
              <div className={styles.insideWrapper}>
                <div className={styles.title}>Select an {modal.data.type}</div>
                <div className={styles.line} />
                <Formik
                  validationSchema={validation}
                  enableReinitialize
                  initialValues={{
                    selected,
                  }}
                  onSubmit={async (values) => {
                    setLoading(true);

                    values.selected.forEach(async (value) => {
                      await modal.action(value);
                    });

                    setLoading(false);
                    setModal({});
                  }}
                >
                  {({
                    errors,
                    touched,
                    values,
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    submitForm,
                  }) => (
                    <Fragment>
                      <Form className={styles.form} onSubmit={handleSubmit}>
                        <div
                          className={styles.fieldRow}
                          style={{ marginBottom: 20 }}
                        >
                          <FieldInput
                            id="selected"
                            type="multi_select"
                            label={`Select your ${modal.data.type}`}
                            options={options}
                            handleChange={(event) => {
                              const values = [];
                              event.forEach((selected) => {
                                values.push(selected.value);
                              });

                              setSelected(values);
                            }}
                            errors={errors.selected}
                            touched={touched.selected}
                            showErrors
                            required
                          />
                        </div>
                      </Form>
                      <div className={styles.footer}>
                        <div className={styles.buttons}>
                          <button
                            className={styles.cancel}
                            onClick={() => setModal("")}
                          >
                            Cancel
                          </button>
                          <button
                            className={styles.save}
                            style={
                              !loading
                                ? { cursor: "pointer" }
                                : { cursor: "default" }
                            }
                            onClick={!loading ? submitForm : null}
                          >
                            {loading ? (
                              <img
                                src={image}
                                alt="loading"
                                style={{ width: "25px" }}
                              />
                            ) : (
                              "Add"
                            )}
                          </button>
                        </div>
                      </div>
                    </Fragment>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        ))}
    </Fragment>
  );
}
